export const UserInfotoolsActionTypes = {
  API_RESPONSE_SUCCESS: '@@users-infotools/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@users-infotools/API_RESPONSE_ERROR',

  GET_USER_INFOTOOLS: '@@users-infotools/GET_USER_INFOTOOLS',
  LIST_USERS_INFOTOOLS: '@@users-infotools/LIST_USERS_INFOTOOLS',
  ADD_USER_INFOTOOLS: '@@users-infotools/ADD_USER_INFOTOOLS',
  UPDATE_USER_INFOTOOLS: '@@users-infotools/UPDATE_USER_INFOTOOLS',
  DELETE_USER_INFOTOOLS: '@@users-infotools/DELETE_USER_INFOTOOLS',

  RESET: '@@users-infotools/RESET'
}
